const IconWallet = (props: any) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M15 5h-1V3.5A1.5 1.5 0 0012.5 2h-10A1.5 1.5 0 001 3.5v11A1.5 1.5 0 002.5 16h12.75a.75.75 0 00.75-.75v-9.5A.75.75 0 0015 5zm-2.5-1.5v1.25H2.5V3.5h10zM2.5 14.5v-7.25h12.75v7.25H2.5z"
      fill="currentColor"
    />
    <path
      d="M12.5 10.5a1 1 0 11-2 0 1 1 0 012 0z"
      fill="currentColor"
    />
  </svg>
);

export default IconWallet;

